import { primaryColor, hexToRgb, whiteColor, blackColor } from 'assets/jss/material-dashboard-pro-react';

const customNavigationButtonsStyle = (theme) => ({
	tab: {
		minWidth: 'auto',
		minHeight: 'auto',
		padding: '0 14px 0 11px',
		margin: '0 2px',
		transition: 'all .2s ease-in-out',
		borderRadius: '4px',
		textTransform: 'none',
		[theme.browser.IE]: {
			marginBottom: '18px',
		},
		[theme.browser.Edge]: {
			marginBottom: '18px',
		},
		'&:hover': {
			backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.16)`,
		},
		'&:active&:hover': {
			backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.3)`,
		},
		'&:first-of-type': {
			marginLeft: 0,
		},
		'&:last-of-type': {
			marginRight: 0,
		},
		'&.Mui-selected': {
			'&': {
				backgroundColor: primaryColor[0],
			},
			'&:hover': {
				backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.88)`,
			},
			'&:active&:hover': {
				background: `linear-gradient(0, rgba(${hexToRgb(blackColor)}, 0.12), rgba(${hexToRgb(
					blackColor
				)}, 0.12)),
        linear-gradient(0, ${primaryColor[0]}, ${primaryColor[0]})`,
			},
			'& .MuiTab-wrapper': {
				color: whiteColor,
			},
			'& p': {
				color: whiteColor,
			},
		},
		'& .MuiTab-wrapper': {
			flexDirection: 'row',
			color: primaryColor[0],
			[theme.browser.IE]: {
				display: 'block',
				marginBottom: '3px',
			},
			'& svg': {
				height: '16px',
				width: 'auto',
				maxWidth: '16px',
				marginBottom: '0!important',
				marginRight: '8px',
				[theme.browser.IE]: {
					verticalAlign: 'middle',
				},
			},
			'& p': {
				marginBottom: 0,
				fontFamily: theme.fontFamily.albert.bold,
				[theme.browser.IE]: {
					whiteSpace: 'nowrap',
					display: 'inline-block',
					verticalAlign: 'middle',
				},
			},
		},
	},
	tabs: {
		height: '40px',
		minHeight: 'auto',
		[theme.browser.IE]: {
			height: '58px',
			marginBottom: '-18px',
		},
		[theme.browser.Edge]: {
			height: '58px',
			marginBottom: '-18px',
		},
		'& .MuiTabs-flexContainer, & .MuiTabs-scroller': {
			height: '100%',
		},
		'& .MuiTabs-flexContainer': {
			[theme.breakpoints.up('md')]: {
				justifyContent: 'center',
			},
		},
		'& .MuiTabs-indicator': {
			display: 'none',
		},
	},
});

export default customNavigationButtonsStyle;
